import { createFileRoute } from '@tanstack/react-router';

import { RfqDetailPage } from '../rfq/detail/RfqDetailPage';

export const Route = createFileRoute('/_app/requests-for-quotes/$id')({
    component: RfqDetailPage,
});
